<template>
  <div class="container">
    <div class="api-response">
      <h5>api response</h5>
      <pre>{{JSON.stringify(resolutionResponse, null, 2)}}</pre>
    </div>
  </div>

</template>


<script>

import axios from "axios";

export default {
  name: "AdminTestPurchaseResolved",
  data() {
    return {
      resolutionResponse: null
    }
  },
  async created() {
    axios.post(`/api/membership/stripe/fulfill-purchase-from-session`, {
      session_id: this.$route.query.session_id
    })
        .then(response => {
          this.resolutionResponse = response.data;
        })
  }
}
</script>


<style scoped>
.api-response {
  color: grey;
  font-family: var(--bs-font-monospace);
  margin-top: 2em;

  pre {
    font-size: x-small;
    height: 20em;
    border-width: thin;
    border-style: solid;
    border-color: lightgrey;
    padding: 1em;
  }
}
</style>